module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"name":"Name","click behaviour":"Klickverhalten","fullscreen":"Fullscreen","ignore":"Ignore","PDF settings":"PDF-Einstellungen","expand pages":"Alle Seiten anzeigen","select pages":"Seiten auswählen","page from":"ab Seite","page to":"bis Seite","caption":"Beschriftung"}}')
  delete Component.options._Ctor
}
